import PropTypes from 'prop-types';

const Abbreviate = ({ fullName }) => {
  const nameArray = fullName?.split(' ');
  return nameArray?.length >= 2 ? `${nameArray[0]} ${nameArray.pop().charAt(0)}.` : fullName;
};

Abbreviate.propTypes = {
  fullName: PropTypes.string.isRequired
};

export { Abbreviate };
